export default "__VITE_ASSET__DZn_sfJm__"